import React from 'react';
import { Helmet } from 'react-helmet';
import { ABOUT_INTRO, ABOUT_META, ABOUT_SECTIONS } from '../content/about';
import { COMPANY } from '../content/company';
import ClosingCta from '../sections/ClosingCta';
import Hero from '../sections/Hero';
import IntroStatement from '../sections/IntroStatement';
import NumberedSection from '../sections/NumberedSection';
import Reveal from '../primitives/Reveal';

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>{ABOUT_META.title}</title>
        <meta name="description" content={ABOUT_META.description} />
        <link rel="canonical" href={`${COMPANY.siteUrl}/about`} />
      </Helmet>

      <Hero image="hero-about" />
      <IntroStatement statement={ABOUT_INTRO.statement} />

      {ABOUT_SECTIONS.map((section) => (
        <NumberedSection key={section.numeral} id={`about-${section.numeral.toLowerCase()}`} numeral={section.numeral} title={section.title}>
          <Reveal>
            <div className="mk-prose t-body">
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </Reveal>
        </NumberedSection>
      ))}

      <ClosingCta
        image="closing-window-coast"
        title="Your health, managed."
        body="One trusted relationship, bringing everything together so you can focus on living well."
      />
    </>
  );
}
